import { Radio, Spin } from 'antd';
import { CustomModal } from './ScenarioColumnEditModal';
import { LoadingOutlined } from '@ant-design/icons';
import { colorConstants } from 'config/colorConstants';
import { useState, useContext, useEffect } from 'react';
import { ResetFieldsType } from 'types/pricingSimulator';
import { pricingSimulatorDataContext } from 'contexts/PricingSimulatorContext';
import { transformFilterObjectWithDimensionsInfo } from 'utils/getPricingSimulatorTableColumns';
import { UserContext } from 'contexts/ConfigContext';
import { ConfigKeys } from 'utils/Enums';
import { getConfig } from 'utils/helperMethods';
import { pricingSimulatorWrapperDataContext } from 'contexts/PricingSimulatorWrapperContext';

type PopupProps = {
    open: boolean;
    onCancel: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onSubmitClick: (payload: any) => void;
    loading: boolean;
};

const ResetConfirmationModal = ({ open, onCancel, loading, onSubmitClick }: PopupProps) => {
    const [applyValue, setApplyValue] = useState<ResetFieldsType>('filtered');
    const {
        dimensionCheckboxObj,
        selectedScenarioInfo,
        isDropdownAtLowestLevel,
        applyFilterObject,
        selectedDimensionListValues,
        searchKey,
    } = useContext(pricingSimulatorDataContext);
    const { dimensionConfigData } = useContext(pricingSimulatorWrapperDataContext);
    const scenarioFilterKeys = dimensionConfigData?.scenarioFilterKeys ?? [];

    const isSelectedItemPresent = Object.keys(dimensionCheckboxObj).length !== 0;

    useEffect(() => {
        if (open) {
            if (isSelectedItemPresent) {
                setApplyValue('selected');
            }
        }
    }, [open]);

    const onSubmitHandler = () => {
        if (loading) return;
        const filters = transformFilterObjectWithDimensionsInfo(applyFilterObject, scenarioFilterKeys);

        const resetPayload: any = {
            scenario_id: selectedScenarioInfo?.scenarioId,
            user_name: localStorage.getItem('email'),
            is_lowest: isDropdownAtLowestLevel,
            filters: filters,
            dimension_attributes: selectedDimensionListValues,
            search_keyword: searchKey,
            row_ids: [],
            row_filters: [],
        };

        switch (applyValue) {
            case 'filtered':
                break;
            case 'selected':
                resetPayload['row_filters'] = Object.keys(dimensionCheckboxObj).map(
                    (d: string) => dimensionCheckboxObj[d].attributeNames,
                );
                resetPayload['row_ids'] = isDropdownAtLowestLevel
                    ? Object.keys(dimensionCheckboxObj).map((d: string) => dimensionCheckboxObj[d].pk)
                    : [];
                break;
            case 'all':
                resetPayload['filters'] = {};
                resetPayload['search_keyword'] = '';
                break;
        }
        onSubmitClick(resetPayload);
    };

    return (
        <CustomModal
            width={400}
            cancelButtonProps={{ style: { borderRadius: 6 } }}
            onCancel={(e) => {
                if (loading) return;
                onCancel(e);
            }}
            onOk={onSubmitHandler}
            title={'Reset Scenario'}
            centered
            open={open}
            okButtonProps={{ type: 'ghost', danger: true, style: { borderRadius: 6 } }}
            okText={loading ? <Spin indicator={antIcon} /> : 'Yes'}
        >
            <p className="pl-2 mb-2">This will reset your edits. Are you sure you want to reset the scenario?</p>
            {/* RADIO BUTTONS section */}
            <Radio.Group
                onChange={(e) => setApplyValue(e.target.value)}
                value={applyValue}
                style={{ display: 'flex', flexDirection: 'column', marginLeft: '10px' }}
            >
                {isSelectedItemPresent && (
                    <Radio
                        disabled={false}
                        style={{ fontSize: 12, color: colorConstants.blackAlt1 }}
                        value={'selected'}
                    >
                        Reset selected records
                    </Radio>
                )}
                <Radio style={{ fontSize: 12, color: colorConstants.blackAlt1 }} value={'filtered'}>
                    Reset all filtered records
                </Radio>
                <Radio disabled={false} style={{ fontSize: 12, color: colorConstants.blackAlt1 }} value={'all'}>
                    Reset all records
                </Radio>
            </Radio.Group>
        </CustomModal>
    );
};
export default ResetConfirmationModal;

export const antIcon = <LoadingOutlined style={{ fontSize: 18, color: 'red' }} spin />;
